<div class="masterswrapper">
   <div class="mastercontent text-heading-3">Master Data - Implant Types</div>
   <div class="d-flex align-items-start">
    <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
      <button class="nav-link active text-heading-6" id="v-pills-body-tab" data-bs-toggle="pill" data-bs-target="#v-pills-body" type="button" role="tab" aria-controls="v-pills-body" aria-selected="true">Body parts</button>
      <button class="nav-link text-heading-6" id="v-pills-implants-tab" data-bs-toggle="pill" data-bs-target="#v-pills-implants" type="button" role="tab" aria-controls="v-pills-implants" aria-selected="false">Implants</button>
      <button class="nav-link text-heading-6" id="v-pills-product-tab" data-bs-toggle="pill" data-bs-target="#v-pills-product" type="button" role="tab" aria-controls="v-pills-product" aria-selected="false">Product categories</button>
      <button class="nav-link text-heading-6" id="v-pills-products-tab" data-bs-toggle="pill" data-bs-target="#v-pills-products" type="button" role="tab" aria-controls="v-pills-products" aria-selected="false">Products</button>
    </div> 
    <div class="tab-content" id="v-pills-tabContent">
      <div class="tab-pane fade show active" id="v-pills-body" role="tabpanel" aria-labelledby="v-pills-body-tab">
        <app-master-bodyparts></app-master-bodyparts>
      </div> 
      <div class="tab-pane fade" id="v-pills-implants" role="tabpanel" aria-labelledby="v-pills-implants-tab">
         <app-master-implants></app-master-implants>
      </div>
      <div class="tab-pane fade" id="v-pills-product" role="tabpanel" aria-labelledby="v-pills-product-tab">
        <app-master-categories></app-master-categories>
      </div>
      <div class="tab-pane fade" id="v-pills-products" role="tabpanel" aria-labelledby="v-pills-products-tab">
        <app-master-products></app-master-products>
      </div>
    </div>
   </div>
</div>